import {
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Typography,
  CircularProgress,
  Box,
  Button,
} from "@mui/material";
import {
  getFeedTypeColor,
  getStatusColor,
  formatDate,
} from "src/utils/feedutils";

export default function FixtureFeedsTableBody({
  feeds,
  loading,
  isLoadingMore,
  handleViewFeedDetails,
}) {
  return (
    <TableBody>
      {feeds.map((feed) => (
        <TableRow
          key={feed.fixtureFeedId}
          sx={{
            "&:last-child td, &:last-child th": { border: 0 },
          }}
        >
          <TableCell component="th" scope="row">
            {feed.fixtureFeedId}
          </TableCell>
          <TableCell>{feed.externalId}</TableCell>
          <TableCell>
            <Chip
              label={feed.feedType}
              color={getFeedTypeColor(feed.feedType)}
              size="small"
            />
          </TableCell>
          <TableCell>
            <Chip
              label={feed.status}
              color={getStatusColor(feed.status)}
              size="small"
            />
          </TableCell>
          <TableCell>{formatDate(feed.createdAt)}</TableCell>
          <TableCell align="center">
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleViewFeedDetails(feed)}
              sx={{ minWidth: "auto" }}
            >
              View Data
            </Button>
          </TableCell>
        </TableRow>
      ))}
      {feeds.length === 0 && !loading && (
        <TableRow>
          <TableCell colSpan={6} align="center">
            <Typography variant="body2" color="textSecondary">
              No feeds found
            </Typography>
          </TableCell>
        </TableRow>
      )}
      {(isLoadingMore || (loading && feeds.length > 0)) && (
        <TableRow>
          <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <CircularProgress size={32} />
              <Typography variant="body2" color="textSecondary">
                Loading more feeds...
              </Typography>
            </Box>
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
}
